import { useEffect, useState} from 'react';
import axios from 'axios';

const useGetRequest = (...getParams) => {
    const [response, setResponse] = useState("");

    const urlParams = getParams.map( getParam => {
            return `${getParam[0]}=${getParam[1]}`
    }).join('&');

    useEffect(() => {
        const data = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}?${urlParams}`);
            setResponse(response.data);
        }

        data()
            .catch(console.error);
    }, [urlParams]); 
    return response;
}

export default useGetRequest;